package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
internal fun EmptySessionsBanner(editable: Boolean) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(bottom = 8.dp)
            .background(SessionAccent.copy(alpha = 0.12f), RoundedCornerShape(10.dp))
            .border(1.dp, SessionAccent.copy(alpha = 0.4f), RoundedCornerShape(10.dp))
            .padding(12.dp),
    ) {
        Text(
            if (editable) {
                "Нет занятий. Добавьте занятие выше — появятся колонка посещаемости и место для ДЗ."
            } else {
                "В этой ведомости пока нет занятий."
            },
            color = SessionAccent,
            fontSize = 14.sp,
        )
    }
}
